import { Box, Text } from "../../../../../../mads";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";

import { colors } from "@indeed/ifl-tokens";
import React from "react";
import { StyleSheet } from "react-native";

/**
 * Renders the salary text and job type inline, mirroring the web
 * `SalaryInfoAndJobType` component used in viewjob's desktop header.
 *
 */
export function SalaryInfoAndJobType() {
  const viewjobOneGraphModel = useViewjobOneGraphModel();
  const salaryText = viewjobOneGraphModel?.compensation?.salaryInfoModel?.salaryText;
  const jobType = viewjobOneGraphModel?.job?.jobType;

  if (!salaryText && !jobType) {
    return null;
  }

  const accessibilityLabel = [salaryText, jobType].filter(Boolean).join(", ");

  return (
    <Box sx={styles.container} accessible accessibilityLabel={accessibilityLabel}>
      {!!salaryText && (
        <Text level={3} sx={styles.text} ariaHidden>
          {salaryText}
        </Text>
      )}
      {!!salaryText && !!jobType && (
        <Text level={3} sx={styles.text} ariaHidden>
          {" -  "}
        </Text>
      )}
      {!!jobType && (
        <Text level={3} sx={styles.text} ariaHidden>
          {jobType}
        </Text>
      )}
    </Box>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  text: {
    color: colors.neutral[1000],
  },
});
